import { render, staticRenderFns } from "./SearchCardDetails.vue?vue&type=template&id=1a46c20b&"
import script from "./SearchCardDetails.vue?vue&type=script&lang=js&"
export * from "./SearchCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./SearchCardDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports